import { Damage } from '@/types';

export type DamageLineView = 'all' | 'review' | 'completed';

const readOriginal = (damage: Damage) => {
  if (!damage.originalData) return undefined;
  try {
    return JSON.parse(damage.originalData) as Record<string, unknown>;
  } catch {
    return undefined;
  }
};

export const originalRepairMethod = (damage: Damage) => {
  const original = readOriginal(damage);
  const description = original?.RepairActionDesc ?? original?.repairActionDesc;
  const code = original?.RepairActionCode ?? original?.repairActionCode;
  return String(description || code || '');
};

export const isRemovedDamageLine = (damage: Pick<Damage, 'isDeleted'>) =>
  !!damage.isDeleted;

export const isChangedDamageLine = (damage: Damage) =>
  !isRemovedDamageLine(damage) &&
  (!!damage.customerChanged || !!damage.internalAmended);

export const isPtReviewRequired = (damage: Damage) =>
  !isRemovedDamageLine(damage) && !!damage.ptReviewRequired;

export const isInternallyAmendedDamageLine = (damage: Damage) =>
  !isRemovedDamageLine(damage) && !!damage.internalAmended;

export const filterDamageLines = (damages: Damage[], view: DamageLineView) =>
  damages.filter((damage) => {
    if (view === 'all') return true;
    const needsReview = isPtReviewRequired(damage);
    if (view === 'review') return needsReview;
    return !isRemovedDamageLine(damage) && !needsReview;
  });
